import { createMemoStyles } from '@wds/utils';

import { PricingAppTheme } from '~app/styles/pricing/types';

const useHubSpotStyles = createMemoStyles<string, {}, PricingAppTheme>(({ spacing }) => ({
  CheckBoxWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: spacing[2],
    '& p': {
      overflowX: 'clip',
    },
  },
}));

export default useHubSpotStyles;
